import { useStateTransition } from "@codesandbox/states";
import { useAddStatusNotification } from "features/notifications/hooks";
import { usePitcherResetLocalToRemote } from "hooks/pitcher/usePitcherResetLocalToRemote";
import { Button, Dialog, Stack } from "prism-react";

import type { UseGlobalModalProps } from "./useGlobalModal";
import { useGlobalModal } from "./useGlobalModal";

const ResetLocalToRemote: React.FC<UseGlobalModalProps> = ({ close }) => {
  const [resetLocalToRemoteState, resetLocalToRemote] =
    usePitcherResetLocalToRemote();
  const addStatusNotification = useAddStatusNotification();

  useStateTransition(resetLocalToRemoteState, "RESOLVED", close);
  useStateTransition(resetLocalToRemoteState, "REJECTED", () => {
    addStatusNotification({
      message: "Not able to reset to remote, please try again",
      status: "error",
    });
  });

  return (
    <>
      <Dialog.Title>Are you sure you want to reset to remote?</Dialog.Title>
      <Dialog.Description>
        You will lose any changes and history that diverge with the remote
        state. Are you sure you want to continue?
      </Dialog.Description>
      <Stack css={{ justifyContent: "flex-end" }} horizontal>
        <Button
          disabled={resetLocalToRemoteState.state === "PENDING"}
          onClick={() => {
            close();
          }}
        >
          No, cancel
        </Button>
        <Button
          loading={resetLocalToRemoteState.state === "PENDING"}
          onClick={() => {
            resetLocalToRemote();
          }}
          variant="primary"
        >
          Yes, reset
        </Button>
      </Stack>
    </>
  );
};

export const useResetLocalToRemoteModal = () =>
  useGlobalModal(ResetLocalToRemote);
